/**
 * 微信公众号绑定账号页面
 * 2020-10-23 wuw
 */
import React from 'react';
import { Radio } from 'antd';
import { Button, Toast, InputItem, NavBar, TextareaItem, Result, Icon } from 'antd-mobile';
import http from '../../../axios/wechatHttp'
import {getUrlParam} from '../../../util/util.js';
import '../financial/FinancialDetail.css'
import 'antd-mobile/dist/antd-mobile.css';
import { createForm } from 'rc-form';
class FinancialDetailForm extends React.Component {
    state = {
        detail: {},
        value: '',
        auditMind: '',   // 审核意见
        status: 0,
        successFlag: false,
        show: false
    }
    componentDidMount() {
        let param = getUrlParam("id");
        this.getfinancialDetail(param)

    }

    onChange = e => {
        this.setState({
            value: e.target.value,
        });
    }
    getfinancialDetail = (id) => {
        http.get({
            url: "/financial/audit/query/detail",
            data: { id: id },
            success: (res) => {
                if (res.status === 1 || res.status === 2) {
                    this.setState({
                        auditMind: res.auditMind,
                        show: true
                    })
                }
                this.setState({
                    detail: res,
                    show: true
                })
            }
        })
    }
    confirmExamine = () => {
        let url = '';
        let value = this.state.value;
        let auditMind = this.state.auditMind;
        if (value !== '') {
            if (value === 1) {
                url = "/financial/audit/success"
            } else if (value === 2) {
                url = "/financial/audit/fail"
            }
            http.post({
                url: url,
                data: {
                    id: this.state.detail.id,
                    auditMind: auditMind
                },
                success: (res) => {
                    this.setState({
                        successFlag: true
                    })
                },
            })
        } else {
            if (value === '') {
                Toast.fail('请选择审核！', 1);
            }
            return
        }
    }
    textAreaInput = (val) => {
        this.setState({
            auditMind: val
        });
    }

    show = () => {
        const {detail, show} = this.state;
        if (show) {
            return (<div>
            <NavBar mode="dark">收款审核</NavBar>
            {!this.state.successFlag ? <div>
                <InputItem value={detail.memberCode ? detail.memberCode : '无'} editable={false}>会员编码</InputItem>
                <InputItem value={detail.name ? detail.name : '无'} editable={false}>会员名称</InputItem>
                <InputItem value={detail.type ? detail.type : '无'} editable={false}>充值类型</InputItem>
                <InputItem value={detail.amount ? detail.amount : '无'} editable={false}>充值金额</InputItem>
                <InputItem value={detail.remark ? detail.remark : '无'} editable={false}>备注</InputItem>
                <div className="am-list-item am-input-item am-list-item-middle">
                    <div className="am-list-line">
                        <div className="am-input-label am-input-label-5">审核</div>
                        <div className="am-input-control">
                            {detail.status === 0 ? <Radio.Group onChange={this.onChange} value={this.state.value}>
                                <Radio value={1}>同意</Radio>
                                <Radio value={2}>不同意</Radio>
                            </Radio.Group> : ''}
                            {detail.status === 1 ? '审核通过' : ''}
                            {detail.status === 2 ? '审核不通过' : ''}
                        </div>
                    </div>
                </div>
                <TextareaItem
                    title="审核意见"
                    value={this.state.auditMind}
                    editable={detail.status === 0}
                    placeholder="选填"
                    autoHeight
                    onChange={this.textAreaInput}
                />
                <div className="auditBtnbox">
                    {detail.status === 0 ? <Button type="primary" disabled={detail.status !== 0} onClick={this.confirmExamine} className="auditBtn">提交</Button> : ''}
                </div>
            </div>
                : <div className="successPage"><Result img={<Icon type="check-circle" className="spe" style={{ fill: '#1F90E6' }} />} title="审核通过" /></div>}
        </div>);
        }
        else {
            return "";
        }
    }
    render() {
        
        return <div className="examinebox">
            {this.show()}
        </div>
    };
}
const FinancialDetail = createForm()(FinancialDetailForm);
export default FinancialDetail;